import { render, staticRenderFns } from "./ProductSideSheetBar.vue?vue&type=template&id=0b9bf1f1&scoped=true"
import script from "./ProductSideSheetBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductSideSheetBar.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ProductSideSheetBar.vue?vue&type=style&index=0&id=0b9bf1f1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9bf1f1",
  null
  
)

export default component.exports